import { TrackingConstant } from 'client/tracking/constant';
import { CREATIVE_ID } from 'site-modules/shared/utils/inventory/srp-utils';

export const GEO_TRACKING_PARAMS = {
  action_name: TrackingConstant.VIEW_SEARCH_RESULT,
  subaction_name: TrackingConstant.FILTER_SEARCH_RESULT,
  creative_id: CREATIVE_ID,
};
